import styled from 'styled-components';

export default styled.span`
  max-width: 200px;
`;
